module.exports = __webpack_public_path__ + "static/img/image-standard@2x.30cff93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx-software/image-standard@2x.png
// module id = O3O6
// module chunks = 12